import { render, staticRenderFns } from "./TaxonomyCustomerGroup.vue?vue&type=template&id=78e9c27f&"
import script from "./TaxonomyCustomerGroup.vue?vue&type=script&lang=ts&"
export * from "./TaxonomyCustomerGroup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports